import { useMutation } from '@apollo/react-hooks'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFlag, faSpinner } from '@fortawesome/free-solid-svg-icons'

import Tooltip from '~/components/shared/Tooltip'
import { CreateReport } from '~/graphql/Message.gql'
import { useToast } from '~/contexts/ToastProvider'
import useError from '~/hooks/useError'
import withLocale from '~/hocs/locale'
import { isLoggedIn } from '~/utils/auth'

const Report = ({ messageId, tooltipText, onAuthRequire }) => {
  const handleOnComplete = () => {
    addToast('success', 'common', 'report.success')
  }

  const handleOnError = error => {
    dispatchError(error)
  }

  const handleReportClick = async () => {
    if (!isLoggedIn()) {
      onAuthRequire()
      return
    }

    const variables = {
      messageId,
    }

    await createReport({ variables })
  }

  const { addToast } = useToast()
  const { dispatchError } = useError()
  const [createReport, { loading, data }] = useMutation(CreateReport, {
    onError: handleOnError,
    onCompleted: handleOnComplete,
  })

  if (loading) return <FontAwesomeIcon icon={faSpinner} className="text-muted" spin />

  if (data) return null

  return (
    <>
      <Tooltip text={tooltipText}>
        <button
          type="button"
          aria-label={tooltipText}
          onClick={handleReportClick}
          className="btn p-0"
        >
          <FontAwesomeIcon
            icon={faFlag}
            className="text-black-50"
          />
        </button>
      </Tooltip>
    </>
  )
}

Report.propTypes = {
  messageId: PropTypes.number.isRequired,
  tooltipText: PropTypes.string.isRequired,
  onAuthRequire: PropTypes.func.isRequired,
}

export default withLocale('common', 'report')(Report)
